import Image from "next/image";

const LeadFormDisclaimer = () => {
  return (
    <div
      id="become-an-agent-leadFormDisclaimer"
      className="flex flex-row items-center gap-3 md:text-xs text-xxs"
    >
      <Image
        id="become-an-agent-disclaimer-image"
        alt="Disclaimer info"
        src="/ethinos-home-page/svgs/disclaimer-info.svg"
        height={15}
        width={15}
      />
      <span id="become-an-agent-disclaimer-text">
        By clicking Start Now, you authorize Niva Bupa to Call/SMS/Whatsapp on your
        registered mobile overriding DNCR.
      </span>
    </div>
  );
};

export default LeadFormDisclaimer;
